import React, {useEffect, useState} from 'react';
import {useForm, useFormState} from 'react-hook-form';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import {useSelector} from 'react-redux';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import {usePolling} from '../../../common/usePolling';
import { Button } from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import {Icon} from '@iconify/react';
import {
  defaultRange,
  getReturns,
  giveCorrectPrice,
  isMobile,
  RegEx,
} from '../../../utils/commonMethods';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {Network} from '../../../utils/network';
import Slippage from '../../portfolio/childComponents/slippage';
import TradingFeeSellCDA from '../../portfolio/childComponents/tradingFeeSellCda';
import {trackMoengageEvent} from '../../../utils/commonMethods';
import BuySellBalanceSection from './BuySellBalanceSection';
import OutCome from '../../portfolio/childComponents/outcome';
import Width from '../../../assets/Width';
import BuyReturn from './BuyReturn';
import {useNavigation, useRoute} from '@react-navigation/native';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {INDIA} from '../../../utils/constants';

const SingleOrderBuyImChild = ({
  eventDetails,
  orderStatus,
  onClick,
  orderBookSelectedData,
  invested_amount,
  isDummy,
  YesSelected,
  setLoader,
  yesNoSelected,
  closeSheet,
}) => {
  const route = useRoute();
  const navigation = useNavigation();
  const contestId = route?.params?.contestId;
  const {
    register,
    handleSubmit,
    formState: {errors, isValid, isSubmitting},
    setValue,
    watch,
    control,
    reset,
  } = useForm({mode: 'onChange'});
  const {dirtyFields} = useFormState({
    control,
  });

  useEffect(() => {
    if (Object.keys(dirtyFields).length <= 0) {
      reset({
        currentPrice: YesSelected
          ? giveCorrectPrice({yPrice: eventDetails?.newYCP})
          : giveCorrectPrice({nPrice: eventDetails?.newNCP}),
        currentAmount: eventDetails?.defaultBuyAmount ?? '100',
      });
    }
  }, [eventDetails?.newYCP, YesSelected]);
  const watchprice = watch('currentPrice');
  const watchamount = watch('currentAmount', 100);
  let globalConfigData = useSelector(
    ({utilReducer}) => utilReducer.globalConfigData,
  );
  const [slippage, setSlippage] = useState(
    globalConfigData?.slippage?.slpType === 'limited' ? true : false,
  );
  let userInfo = useSelector(({profile}) => profile.profileData);
  const logedIn = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const isSmileEvent = eventDetails?.probe_type === 'promo';
  const walletBalance = parseFloat(
    !isSmileEvent ? userInfo?.maxTradeableAmount : userInfo?.coinsp,
  )?.toFixed(2);

  let isDisableTradePrivate = false;

  useEffect(() => {
    getUpdatedPrice();
  }, [watchamount]);

  const getRoi = () => {
    var roi = 0;
    if (watchprice && watchamount && watchprice > 0 && watchamount > 0) {
      roi = ((watchamount * 100) / watchprice / watchamount).toFixed(2);
    }

    return roi;
  };

  useEffect(() => {
    if (Object.keys(dirtyFields).length > 0) {
      if (YesSelected) {
        //setYesSelected(true);
        const amount = watchamount;
        setValue('currentAmount', eventDetails?.defaultBuyAmount ?? '100', {
          shouldValidate: true,
          shouldDirty: true,
        });
        if (amount === 100) {
          getUpdatedPrice('Y', true);
        }
        //setTradingFee((watchamount * 0.01)?.toFixed(2));
      } else {
        //setYesSelected(false);
        const amount = watchamount;
        setValue('currentAmount', eventDetails?.defaultBuyAmount ?? '100', {
          shouldValidate: true,
          shouldDirty: true,
        });
        if (amount === 100) {
          getUpdatedPrice('N', true);
        }
        //setTradingFee((watchamount * 0.01)?.toFixed(2));
      }
    }
  }, [YesSelected]);

  usePolling(
    () => {
      getUpdatedPrice();
    },
    5000,
    true,
  );

  const getUpdatedPrice = async (
    isYesSelected = null,
    isLoaderShow = false,
  ) => {
    if (watchamount > 0 && watchamount <= 1000000 && true) {
      const data = {
        eventId: eventDetails?.id,
        action: 'buy',
        callvalue: isYesSelected ? isYesSelected : YesSelected ? 'Y' : 'N',
        amount: watchamount,
        shares: 1,
        variableLiquidity: eventDetails?.is_variable_liquidity_pool,
      };
      //if (isLoaderShow) setLoaderActive(true);

      try {
        let res;
        if (data.variableLiquidity) {
          res = await Network.getUpdatedPrice(data);
        } else {
          res = await Network.getTruePrice(data);
        }

        //if (isLoaderShow) setLoaderActive(false);
        if (res?.data?.success) {
          setValue(
            'currentPrice',
            giveCorrectPrice(
              isYesSelected
                ? {yPrice: res?.data?.data?.ex_price}
                : {nPrice: res?.data?.data?.ex_price},
            ),
          );
          return res?.data;
        }
      } catch (e) {
        //if (isLoaderShow) setLoaderActive(false);
        throw e;
      }
    }
  };

  let region = userInfo?.region_code ?? 'INDIA';
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    setIsPlacingOrder(true);
    try {
      let inputObj = {
        appVersion: globalConst.appVersion,
        callvalue: YesSelected ? 'Y' : 'N',
        coins: `${data.currentAmount}`,
        noofcontracts: 1,
        probeid: eventDetails?.id,
        proptionid: YesSelected ? 9 : 10,
        ptype: 'bet',
        tradeType: 'Buy',
        preventSlippage: slippage,
        trade_initiated_price: parseFloat(watchprice)?.toFixed(2),
        range: defaultRange.end,
      };
      inputObj = {
        ...inputObj,
        ...{
          trade_initiated_price: parseFloat(inputObj.trade_initiated_price),
        },
      };
      if (!isSubmitting) {
        const res = await Network.buyOrder(inputObj, true);

        if (res?.success) {
          res.data.coins = watchprice;
        }

        trackMoengageEvent('Event Buy', {
          id: eventDetails?.id,
          status: res?.data?.success ? 'successful' : 'failed',
          Side: YesSelected ? 'Yes' : 'No',
          trade_initiated_price: parseFloat(watchprice)?.toFixed(2),
          Category: eventDetails?.category,
          SubCategory: eventDetails?.subcategory,
          price: `${data.currentAmount}`,
          Type: 'IM',
          slippage: inputObj?.preventSlippage === true ? 'Limited' : 'Unlimited',
          PresentValue: YesSelected
            ? eventDetails?.currentPrice?.newYCP
            : eventDetails?.currentPrice?.newNCP,
          orderboolClicked: orderBookSelectedData != null ? 'Yes' : 'No',
          MarketOpen: new Date(eventDetails?.createdat),
          MarketEnd: new Date(eventDetails?.endsat),
          MarketSettlement: new Date(eventDetails?.settledate),
          SettlementLink: eventDetails?.source,
          isContest: contestId ? true : false,
        });
        orderStatus(res);
      }
    } catch (error) {
      console.error('Order placement error:', error);
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const handleSlippage = e => {
    // e.preventDefault();
    setSlippage(!slippage);
  };

  const onCounterAmountUpdate = (action) => {
    const currentAmount = watch('currentAmount');
    const newValue = action === 'increment' ? currentAmount + 1 : currentAmount - 1;
    setValue('currentAmount', newValue.toString(), {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <View>
      <ScrollView
        style={globalStyle.buySellScroll}
        showsVerticalScrollIndicator={false}>
        <TouchableOpacity activeOpacity={1}>
          <OutCome YesSelected={YesSelected} yesNoSelected={yesNoSelected} />
          <View
            style={[
              globalFormStyle.tableContainerRowNewForm,
              {alignItems: 'flex-start'},
            ]}>
            <FormTextLabel labelStyles={styles.formTitle} label={'Price'} />

            <View>
              <Text
                style={[
                  globalFormStyle.fieldRight,
                  {
                    color: globalConfigurableData.primaryTextColor1,
                    textAlign: 'right',
                  },
                ]}>
                {(1 * watchprice)?.toFixed(2)}
              </Text>
              <FormTextLabel
                labelStyles={globalFormStyle.fieldRight}
                label={'At Market'}
              />
            </View>
          </View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: 5,
            }}>
            <FormTextLabel labelStyles={styles.formTitle} label={'Amount'} />
          </View>
          <View style={{
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: globalConfigurableData.cardBgColor,
            borderRadius: 8,
            borderWidth: 1,
            overflow: 'hidden',
            borderColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
          }}>
            <TouchableOpacity
              onPress={() => onCounterAmountUpdate('decrement')}
              style={{
                height: 46,
                width: 46,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon
                icon="mdi:minus"
                width={20}
                height={20}
                color={globalConfigurableData.primaryTextColor1}
              />
            </TouchableOpacity>
            <View style={{
              width: 1,
              alignSelf: 'stretch',
              backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
            }} />
            <View style={{flex: 1}}>
              <Input
                name="currentAmount"
                placeholder=""
                control={control}
                variant="large"
                disabled={!logedIn}
                containerStyle={{marginBottom: 0}}
                style={{borderWidth: 0}}
                inputStyle={{
                  borderWidth: 0,
                  backgroundColor: 'transparent',
                  textAlign: 'center',
                }}
                fullWidth
                numeric={true}
                rules={{
                  required: true,
                  pattern: {
                    value: RegEx.tradeNum,
                    message: 'Please enter a valid amount',
                  },
                  min: {
                    value: 1,
                  },
                  max: {
                    value: 200000,
                  },
                }}
              />
            </View>
            <View style={{
              width: 1,
              alignSelf: 'stretch',
              backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
            }} />
            <TouchableOpacity
              onPress={() => onCounterAmountUpdate('increment')}
              style={{
                height: 46,
                width: 46,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon
                icon="mdi:plus"
                width={20}
                height={20}
                color={globalConfigurableData.primaryTextColor1}
              />
            </TouchableOpacity>
          </View>
          {errors?.currentAmount?.type === 'max' && (
            <FormTextLabel
              labelStyles={globalStyle.errorText}
              label={
                'Cannot purchase shares worth more than Rs. 200000 at a time'
              }
            />
          )}

          <BuySellBalanceSection
            walletBalance={walletBalance}
            slippage={slippage}
            handleSlippage={handleSlippage}
            isShowSlippage={eventDetails?.is_variable_liquidity_pool}
            isSmileEvent={isSmileEvent}
          />

          <BuyReturn
            isSmileEvent={isSmileEvent}
            investment={watchamount}
            returns={parseFloat(
              (watchamount * 100) / getReturns(watchprice),
            )?.toFixed(2)}
          />

          {/* <View style={globalFormStyle.tableContainerRowNewForm}>
            <Text style={globalFormStyle.fieldLeft}>Est. Shares</Text>

            <Text style={globalFormStyle.fieldRight}>
              {(watchamount / watchprice)?.toFixed(2)}
            </Text>
          </View> */}
          {/* <View style={globalFormStyle.tableContainerRowNewForm}>
            <Text style={globalFormStyle.fieldLeft}>Potential Returns</Text>
            <Text>
              <Text style={globalFormStyle.fieldRight}>
                {parseFloat((watchamount * 100) / watchprice)?.toFixed(2)}
              </Text>
              <Text style={globalFormStyle.fieldBlue}>
                &nbsp;(ROI&nbsp;:&nbsp;{getRoi()} X)
              </Text>
            </Text>
          </View> */}
          {logedIn ? <TradingFeeSellCDA configKey={'tfIMBuy'} /> : null}
        </TouchableOpacity>
      </ScrollView>
      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15, marginTop: 0},
        ]}>
        <Button
          variant={YesSelected ? "yes" : "no"}
          onPress={() => {
            setTimeout(() => {
              handleSubmit(onPlaceOrder)();
            }, globalConst.buttonTimer);
          }}
          disabled={!isValid || isDisableTradePrivate}
          loading={isPlacingOrder}
          loadingText={isDummy ? "Processing..." : "Placing Order..."}
          style={{
            minHeight: 48,
            borderRadius: 8,
            opacity: (!isValid || isDisableTradePrivate) ? 0.6 : 1,
          }}
          textStyle={{
            ...globalFontStyle.appFontBody,
            color: Colors.bgWhite,
          }}
          translate
        >
          {isDummy ? 'Next' : 'Confirm Order'}
        </Button>
      </View>
    </View>
  );
};

export default SingleOrderBuyImChild;

const styles = StyleSheet.create({
  btnExternalStyle: {
    borderRadius: 100,
  },
  formTitle: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.secondaryTextColor1,
  },
  maxShareText: {
    ...globalFontStyle.appFontSmallTextBold,
    color: GlobalScreens.SingleOrder.highlightColor,
  },
  fieldBottomText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
});
